import { createStyles, lighten, makeStyles } from "@material-ui/core";

import { RelodeTheme } from "../";

export const useEnhancedTableStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                width: "100%",
            },
            tableWrapper: {
                overflowX: "auto",
            },
            tableCell: {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                height: theme.spacing(8),
            },
            expansionTableCell: {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                border: "none",
            },
            select: {
                paddingRight: 26,
            },
            selectIcon: {
                color: theme.palette.primary.main,
            },
            boldText: {
                fontWeight: "bold",
            },
            truncateText: {
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: 0,
            },
            firstColumn: {
                paddingLeft: 0,
            },
            smallestColumn: {
                width: "5%",
            },
            smallerColumn: {
                width: "8%",
            },
            smallColumn: {
                width: "10%",
            },
            mediumColumn: {
                width: "15%",
            },
            largeColumn: {
                width: "20%",
            },
            largerColumn: {
                width: "25%",
            },
            largestColumn: {
                width: "40%",
            },
            fillColumn: {
                width: "100%",
            },
            expansionRow: {
                padding: 0,
                borderTop: "none",
            },
            rowBody: {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(1),
            },
            tableCellLink: {
                display: "unset",
            },
            tableToolBarRoot: {
                paddingRight: 0,
                paddingLeft: 0,
            },
            highlight:
                theme.palette.type === "light"
                    ? {
                          color: theme.palette.primary.main,
                          backgroundColor: lighten(
                              theme.palette.primary.light,
                              0.85
                          ),
                      }
                    : {
                          color: theme.palette.text.primary,
                          backgroundColor: theme.palette.secondary.dark,
                      },
            actions: {
                color: theme.palette.text.secondary,
                flexWrap: "nowrap",
                display: "flex",
            },
            title: {
                flex: "0 0 auto",
            },
            selectedTitle: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            tableRowExpanded: {
                backgroundColor: theme.palette.grey[200],
            },
        }),
    { name: "enhancedTableStyles" }
);
